class ShipTypeRange {
    public Ymin: number = 0
    public Ymax: number = 0
    public DWTmin: number = 0
    public DWTmax: number = 0
}

export default ShipTypeRange